export const PAYMENT_METHODS_ROUTES_CONSTANTS = Object.freeze({
  HOME: '/home',
});
